import React from "react";
import SegmentedControl from "Utils/Utils/SegmentedControl";
import { MODO_PACAS, MODO_SOBRANTE } from "../hooks/useReprocesoCarga";
import { ModalReproceso } from "./ModalReproceso/ModalReproceso";
import { AvisoPalletsOcultos } from "../../../../../components/AvisoPalletsOcultos";

const OPCIONES_MODO = [
    { value: MODO_PACAS, label: "Pacas de pallets" },
    { value: MODO_SOBRANTE, label: "Sobrante" },
];

// Reemplaza a la báscula cuando el almacén es de reproceso: los kg de la carga
// salen de las pacas o del sobrante que se toman del inventario del almacén, y
// la carga se agrega desde el mismo modal
export const ContenidoReproceso = ({ cargasFormHook }) => {
    const reprocesoHook = cargasFormHook.reproceso;
    const { esModoPacas, nombreAlmacen } = reprocesoHook;

    return (
        <React.Fragment>
            <div
                className="d-flex pt-3 pb-4 px-3 gap-1rem flex-wrap align-items-end"
                style={{ backgroundColor: "#ebebeb", borderRadius: "1rem" }}
            >
                <div className="formulario-field">
                    <label className="text-nowrap">Tipo de reproceso</label>
                    <SegmentedControl
                        options={OPCIONES_MODO}
                        value={reprocesoHook.modo}
                        onChange={reprocesoHook.setModo}
                    />
                </div>

                <div className="formulario-field">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={reprocesoHook.AbrirModal}
                        disabled={!reprocesoHook.hayDisponibles}
                        style={{ maxWidth: "10rem" }}
                    >
                        {esModoPacas ? "Agregar pacas" : "Agregar sobrante"}
                    </button>
                </div>
                <div className="formulario-field"></div>
            </div>

            {!reprocesoHook.hayDisponibles && (
                <small className="text-danger">
                    {esModoPacas
                        ? "Este almacén no tiene pacas disponibles en reproceso."
                        : "Este almacén no tiene sobrante disponible en reproceso."}
                </small>
            )}

            {esModoPacas && (
                <AvisoPalletsOcultos
                    pallets={reprocesoHook.palletsOcultos}
                    motivoSingular={`llegó a ${nombreAlmacen} después de la fecha y hora del reloj de producción`}
                    motivoPlural={`llegaron a ${nombreAlmacen} después de la fecha y hora del reloj de producción`}
                />
            )}

            <ModalReproceso cargasFormHook={cargasFormHook} />
        </React.Fragment>
    );
};
